import { ITimesheetRepository } from "domain/contracts/timesheet.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { Timesheet } from "domain/entities/timesheet";
import { TimesheetInputFilter } from "domain/models/timesheet-input-filter";
import { TimesheetNotifyInputFilter } from "domain/models/timesheet-notify-input-filter";
import { TimesheetNotifyOutputFilter } from "domain/models/timesheet-notify-output-filter";

class TimesheetRepository implements ITimesheetRepository {
  async notify(
    input: TimesheetNotifyInputFilter
  ): Promise<Message<TimesheetNotifyOutputFilter>> {
    const response = await httpClient.post(`/timesheet/notifyPending`, {
      data: input,
    });
    return response.data;
  }
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/timesheet/${id}`);
    return response.data;
  }

  async create(input: Timesheet): Promise<Message<Timesheet>> {
    const response = await httpClient.post(`/timesheet`, { data: input });
    return response.data;
  }

  async createAll(input: Timesheet): Promise<Message<Timesheet[]>> {
    const response = await httpClient.post(`/timesheet/setting`, {
      data: input,
    }, {
      timeout: 0
    });
    return response.data;
  }

  async update(input: Timesheet): Promise<Message<boolean>> {
    const response = await httpClient.put(`/timesheet/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async blockAll(input: Timesheet): Promise<Message<boolean[]>> {
    const response = await httpClient.put(`/timesheet/setting/block`, {
      data: input,
    });
    return response.data;
  }

  async unlockAll(input: Timesheet): Promise<Message<boolean[]>> {
    const response = await httpClient.put(`/timesheet/setting/unlock`, {
      data: input,
    });
    return response.data;
  }

  async getAll(filter: TimesheetInputFilter): Promise<Message<Timesheet[]>> {
    const response = await httpClient.get(`/timesheet`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<Timesheet>> {
    const response = await httpClient.get(`/timesheet/${id}`);
    return response.data;
  }
}

export default new TimesheetRepository();
